import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { MembersTable } from '../../slug_conflict';
const containerCss = "cwdrlhj";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const textContainerCss = "t17d7wdq";
const TextContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textContainerCss, props.className)} />;
});
export const GroupsSlugConflict = ({
  slug,
  memberships
}) => <Container>
    <TextContainer>
      <BodyText>
        {HtmlParser(I18n.t('publisher.organization.managed_event_types.assign.groups_slug_conflict.line_1', {
        count: memberships.length,
        slug
      }))}
      </BodyText>
    </TextContainer>
    <MembersTable memberships={memberships} />
    <TextContainer>
      <BodyText>
        {I18n.t('publisher.organization.managed_event_types.assign.groups_slug_conflict.line_2')}
      </BodyText>
    </TextContainer>
  </Container>;

require("./groups_slug_conflict.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./groups_slug_conflict.js");